module.exports = __webpack_public_path__ + "img/rockwool-sns.d51d2cd1.png";